import * as React from 'react';
import { Link } from 'shared/components/Link';
import { useTranslation } from 'react-i18next';
import b_ from 'b_';
import { GenericInfoContainer } from 'components/GenericInfoContainer';

import './index.scss';

import emptyIcon from './static/img/empty-icon.svg';

const b = b_.with('stocks-list-empty');

export const EmptyList: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GenericInfoContainer
      icon={<img src={emptyIcon} alt="<>" />}
      title={t('This section is temporarily unavailable due to technical reasons')}
      subtitle={
        <>
          <p className={b('paragraph')}>
            {t(
              'If you already have such investments, and you wish to close them, you can do it in the section My portfolio'
            )}
            .
          </p>
          <p className={b('paragraph')}>
            {t(
              'We are working hard to restore your access as soon as possible Thank you for your patience'
            )}
          </p>
        </>
      }
      control={
        <Link className={b('btn')} to="/investments">
          {t('View current ideas')}
        </Link>
      }
      data-testid="empty-stocks-list"
    />
  );
};
